import { LoadSpinCommand } from "slotworks/commands/comms/load-spin-command";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import Components from "slotworks/components/components";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import { parallel } from "slotworks/utils/race-utils";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import Timer from "slotworks/utils/timer";
import Regulation from "slotworks/integration/revolver/regulations/regulation";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";

export default class RequestSpin extends State {
    public static WINNINGS_RESET_DELAY: number = 1500;
    public static MINIMUM_TIME_BETWEEN_SPINS: number = 3000;

    private skipping: boolean;
    private lastSpinTime: number;

    public onEnter(cascadeSkip?: boolean) {
        if(settingsModel.isJurisdiction(Jurisdiction.SE)) {
            if(!this.lastSpinTime || this.lastSpinTime + RequestSpin.MINIMUM_TIME_BETWEEN_SPINS < Date.now()) {
                this.spin(cascadeSkip)
            }
            else {
                Timer.setTimeout(()=>{
                    this.spin(cascadeSkip);
                },
                RequestSpin.MINIMUM_TIME_BETWEEN_SPINS - (Date.now() - this.lastSpinTime));
            }
        }
        else {
            this.spin(cascadeSkip);
        }
    }

    private spin(cascadeSkip?: boolean) {
        this.lastSpinTime = Date.now();
        this.skipping = cascadeSkip;

        this.newGame();

        if(!CampaignsModel.isFreespinsActive()){
            SmartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, true);
        }

        Components.footer.showSpinStart(BetModel.getTotalBet());

        parallel([
            () => StartSpinCommand(),
            () => LoadSpinCommand()
        ]).then(() => {
            if (!GameState.getCurrentGame().getCurrentRecord()) {
                Components.matrix.reset();
                this.error();
            } else {
                GameState.getCurrentGame().totalBet = BetModel.getTotalBet();
                if (this.skipping) {
                    this.skip();
                } else {
                    this.complete();

                }
            }
        });
    }

    public onSkip() {
        this.skipping = true;
    }

    public onExit() {
        if(!CampaignsModel.isFreespinsActive()){
            SmartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, false);
        }
    }

    protected newGame() {
        if(campaignsModel.isFreespinsActive()) {
            GameState.newGame();
        } else {
            GameState.newGame(BetModel.getTotalBet());
        }        
        Regulation.interactionStart();
        Components.betBar.winnings.setDelayedWinnings(0, 0, RequestSpin.WINNINGS_RESET_DELAY);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/request-spin.ts